// extracted by mini-css-extract-plugin
export var productImage = "_mr-0";